"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _homepageCarSelector = _interopRequireDefault(require("../styles/homepage-car-selector.css"));
var _homepageCarSelectorEntry = _interopRequireDefault(require("./homepage-car-selector-entry"));
var _div;
var lowerLimitOfCarouselItems = 50;
var scrollTolerance = '.6';
var getExpandedProductArray = function getExpandedProductArray(props) {
  var selectedCardValue = props.selectedCardValue,
    products = props.products;
  var expansionFactor = Math.ceil(lowerLimitOfCarouselItems / products.length);
  var expandedProductArray = [];
  for (var i = 0; i <= expansionFactor; i++) {
    expandedProductArray = expandedProductArray.concat(products.slice());
  }
  var centeredModel = expandedProductArray[Math.floor(expandedProductArray.length / 2)];
  if (selectedCardValue && selectedCardValue !== 'undefined' && centeredModel.code + "_" + centeredModel.year !== selectedCardValue) {
    var replacingModelIndex = '',
      shouldBeCenteredModelIndex = '';
    expandedProductArray.map(function (model, index) {
      if (model.name === centeredModel.name) {
        replacingModelIndex = index;
      }
      if (model.code + "_" + model.year === selectedCardValue) {
        shouldBeCenteredModelIndex = index;
      }
      if (replacingModelIndex !== '' && shouldBeCenteredModelIndex !== '') {
        var tempCard = expandedProductArray[shouldBeCenteredModelIndex];
        expandedProductArray[shouldBeCenteredModelIndex] = centeredModel;
        expandedProductArray[replacingModelIndex] = tempCard;
        replacingModelIndex = '';
        shouldBeCenteredModelIndex = '';
      }
    });
  }
  return expandedProductArray;
};
var MobileCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(MobileCarousel, _React$Component);
  MobileCarousel.resourceType = function resourceType() {
    return 'MobileCarousel_1_0_0';
  };
  function MobileCarousel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var vehicleObject = props.vehicleObject;
    var expandedProductArray = getExpandedProductArray(props) || [];
    var centeredItemIndex = Math.floor(expandedProductArray.length / 2);
    var tileWidth = 0;
    if (vehicleObject && vehicleObject.code && props.handleChangeEvent !== null) {
      var selectedItemIndex = expandedProductArray.findIndex(function (vehicle, i) {
        return vehicleObject.code === vehicle.code && String(vehicleObject.year) === String(vehicle.year) && i > centeredItemIndex;
      });
      if (selectedItemIndex >= 0) {
        centeredItemIndex = selectedItemIndex;
      }
    }
    if (typeof window !== 'undefined') {
      tileWidth = window.innerWidth * 0.6;
    }
    _this.state = {
      tileWidth: tileWidth,
      centeredItemIndex: centeredItemIndex,
      selectedItemIndex: centeredItemIndex,
      recentControlledScroll: false,
      centeredItemLabel: expandedProductArray[centeredItemIndex].code + "_" + expandedProductArray[centeredItemIndex].year,
      expandedProductArray: expandedProductArray
    };
    _this.isScrolling = null;
    _this.recentControlledScroll = false;
    _this.scrollablePane = /*#__PURE__*/_react["default"].createRef();
    _this.checkScrolling = _this.checkScrolling.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleScrollStop = _this.handleScrollStop.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePrevious = _this.handlePrevious.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleNext = _this.handleNext.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = MobileCarousel.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var centeredItemIndex = this.state.centeredItemIndex;
    var scrollablePaneEl = this.scrollablePane.current;
    if (typeof window !== 'undefined' && scrollablePaneEl) {
      // Scroll to centered tile
      this.scrollToTile(centeredItemIndex);

      // Listen for scroll events
      scrollablePaneEl.addEventListener('scroll', this.checkScrolling, false);
      window.addEventListener('resize', this.handleResize, false);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var scrollablePaneEl = this.scrollablePane.current;

    // Unlisten for scroll events
    if (typeof window !== 'undefined' && scrollablePaneEl) {
      scrollablePaneEl.removeEventListener('scroll', this.checkScrolling, false);
      window.removeEventListener('resize', this.handleResize, false);
    }
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (newProps.selectedMobileIndex !== null) {
      var expandedProductArray = getExpandedProductArray(newProps);
      var centeredItemIndex = Math.floor(expandedProductArray.length / 2);
      this.setState({
        expandedProductArray: expandedProductArray,
        centeredItemIndex: centeredItemIndex,
        centeredItemLabel: expandedProductArray[centeredItemIndex].code + "_" + expandedProductArray[centeredItemIndex].year
      });
    }
  };
  _proto.handleResize = function handleResize(e) {
    this.setState({
      tileWidth: window.innerWidth * 0.6
    });
  };
  _proto.checkScrolling = function checkScrolling(e) {
    var _this2 = this;
    var tileWidth = this.state.tileWidth;
    if (this.isScrolling === null) {
      var currentLeftScroll = this.scrollablePane.current.scrollLeft;
      // Only clear if we have not snapped to a tile
      if (!String(currentLeftScroll / tileWidth).includes(scrollTolerance)) {
        this.setState({
          centeredItemLabel: ''
        });
      }
    }
    // Clear our timeout throughout the scroll
    window.clearTimeout(this.isScrolling);

    // Set a timeout to run after scrolling ends
    this.isScrolling = setTimeout(function () {
      // Run the callback
      _this2.handleScrollStop(e);
    }, 166);
  };
  _proto.scrollToTile = function scrollToTile(indexToScrollTo, isSmooth) {
    var _this3 = this;
    this.recentControlledScroll = true;
    var scrollablePaneEl = this.scrollablePane.current;
    var paneClassList = scrollablePaneEl.classList;
    var tileWidth = window.innerWidth * 0.6;
    if (isSmooth !== true) {
      paneClassList.add(_homepageCarSelector["default"].isControlled);
    }
    scrollablePaneEl.scrollLeft = indexToScrollTo * tileWidth - tileWidth * 0.33;
    if (isSmooth !== true) {
      paneClassList.remove(_homepageCarSelector["default"].isControlled);
    }
    window.setTimeout(function () {
      return _this3.recentControlledScroll = false;
    }, 100);
  };
  _proto.handleScrollStop = function handleScrollStop(e) {
    var _this$state = this.state,
      expandedProductArray = _this$state.expandedProductArray,
      tileWidth = _this$state.tileWidth;
    var scrollablePaneEl = this.scrollablePane.current;
    if (typeof window !== 'undefined' && scrollablePaneEl && !this.recentControlledScroll) {
      var currentLeftScroll = scrollablePaneEl.scrollLeft;
      var exactTilePlacement = currentLeftScroll / tileWidth;
      if (String(exactTilePlacement).includes(scrollTolerance)) {
        var centeredTileIndex = Math.ceil(exactTilePlacement);
        var centeredTileLabel = expandedProductArray[centeredTileIndex].code + "_" + expandedProductArray[centeredTileIndex].year;
        var indexToScrollTo = expandedProductArray.findIndex(function (label, i) {
          return label.code + "_" + label.year === centeredTileLabel && i > (expandedProductArray.length - 10) / 2;
        });
        if (currentLeftScroll < tileWidth * 15 || currentLeftScroll > tileWidth * 35) {
          this.scrollToTile(indexToScrollTo);
        }
        this.setState({
          centeredItemIndex: indexToScrollTo,
          centeredItemLabel: centeredTileLabel
        });
      }
      this.isScrolling = null;
    }
  };
  _proto.handleNext = function handleNext() {
    var tileWidth = this.state.tileWidth;
    var scrollablePaneEl = this.scrollablePane.current;
    scrollablePaneEl.scrollLeft += tileWidth;
  };
  _proto.handlePrevious = function handlePrevious() {
    var tileWidth = this.state.tileWidth;
    var scrollablePaneEl = this.scrollablePane.current;
    scrollablePaneEl.scrollLeft -= tileWidth;
  };
  _proto.renderCards = function renderCards() {
    var _this$state2 = this.state,
      expandedProductArray = _this$state2.expandedProductArray,
      centeredItemLabel = _this$state2.centeredItemLabel,
      centeredItemIndex = _this$state2.centeredItemIndex;
    var _this$props = this.props,
      theme = _this$props.theme,
      selectedMobileIndex = _this$props.selectedMobileIndex,
      selectedCardValue = _this$props.selectedCardValue,
      selectedLabel = _this$props.selectedLabel,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId,
      disclaimerData = _this$props.disclaimerData;
    var handleChangeEvent = this.props.handleChangeEvent;
    if (expandedProductArray && expandedProductArray.length > 0) {
      return expandedProductArray.map(function (oneTile, index) {
        var classesToPass = [_homepageCarSelector["default"].productTile];
        if (centeredItemLabel === oneTile.code + "_" + oneTile.year) {
          classesToPass.push(_homepageCarSelector["default"].isCentered);
        }
        return /*#__PURE__*/_react["default"].createElement(_homepageCarSelectorEntry["default"], {
          key: oneTile.code + "_" + oneTile.year + "--" + index,
          oneTile: oneTile,
          classes: classesToPass,
          theme: theme,
          customId: oneTile.code + "_" + oneTile.year + "--" + index,
          handleChangeEvent: handleChangeEvent,
          selectedValue: selectedCardValue + "--" + selectedMobileIndex,
          selectedLabel: selectedLabel,
          addPriceDisclaimer: addPriceDisclaimer,
          priceDisclaimerId: priceDisclaimerId,
          disclaimerData: disclaimerData
        });
      });
    }
    return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
  };
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].mobileContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _homepageCarSelector["default"].productWrapper + " " + _homepageCarSelector["default"].isControlled,
      ref: this.scrollablePane
    }, this.renderCards()), /*#__PURE__*/_react["default"].createElement("button", {
      className: _homepageCarSelector["default"].previous,
      onClick: this.handlePrevious
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _homepageCarSelector["default"].srOnly
    }, "&#8592")), /*#__PURE__*/_react["default"].createElement("button", {
      className: _homepageCarSelector["default"].next,
      onClick: this.handleNext
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _homepageCarSelector["default"].srOnly
    }, "\u2192")));
  };
  return MobileCarousel;
}(_react["default"].Component);
exports["default"] = MobileCarousel;
MobileCarousel.displayName = 'MobileCarousel';